import React, { useState, useEffect, useRef } from 'react';
import Button from "../../../../button/button";
import InputAnimated from "../../../../inputAnimated/inputAnimated";
import InputDate from "../../../../inputDate/inputDate";
import Select from "../../../../select/select";
import Tooltip from "../../../../Tooltip/Tooltip";
import CloseSVG from "../../../../icons/close";
import EditSVG from "../../../../icons/edit";
import './StudentSection.scss';
import PaymentHistory from "../PaymentHistory/PaymentHistory";
import { useNavigate } from "react-router-dom";
import Axios from 'axios'
import PasswordAlert from '../../../../passwordAlert/passwordAlert';
import InputAutoComplete from '../../../../autocomplete/autocomplete';
import { PostReceptionistInCharge } from '../../../../../utils/Apis/apis';
import { formatToLocalDate, getLocalDateObject } from '../../../../../utils/dateTimeZone';
const StudentSection = ({ studentsList = [], student, setStudents, removeStudentSection, index, books, amountInscription, showAlert }) => {
    // const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(null);
    // const navigate = useNavigate();
    //ALERT
    const [showInscription, setShowInscription] = useState(false)
    const [inscriptionValue, setInscriptionValue] = useState('');
    const [paymentPlan, setPaymentPlan] = useState({})
    const [scholarShip, setScholarShip] = useState({})
    const [studentPay, setStudentPay] = useState(0)
    const [studentPaymentHistory, setStudentPaymentHistory] = useState([])
    const [inscriptionDate, setInscriptionDate] = useState('')
    const [buttonsState, setButtonState] = useState({
        disabled_inscription: false
    })
    const [disableTuition, setDisabledTuition] = useState(true)
    const [disableInscriptionInput, setDisabledInscriptionInput] = useState(true)
    const [isStudentClassOnline, setIsStudentClassOnline] = useState(false)
    const appliedPromoIdsRef = useRef(new Set());
    const [observation, setObservation] = useState('');

    //Modal
    // Define el estado para los handlers del modal
    const [modalHandlers, setModalHandlers] = useState({
        handleAcceptPassword: () => { },
        handleCancelPassword: () => { },
    });
    const [isPasswordRequired, setIsPasswordRequired] = useState(false);
    const GetAllPaymentInfoByStudent = async (studentId) => {
        try {
            const res = await Axios.post(
                process.env.REACT_APP_API_URL + "getAllPaymentInfoByStudent/",
                { studentId },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error("Error obteniendo los recibos del alumno", error);
            return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
        }
    };
    // Handle student selection and update payment history
    const handleStudentChange = async (selectedStudentId) => {
        if (!selectedStudentId) {
            // Si no hay selección (es decir, si el valor es null o undefined), puedes manejarlo aquí
            console.log("No student selected.");
            return; // Sale de la función sin hacer nada
        }

        const selectedStudent = studentsList.find(s => s.id === parseInt(selectedStudentId.id));
        if (!selectedStudent) {
            return; // Si no se encuentra el estudiante, sale de la función
        }
        setIsStudentClassOnline(selectedStudent.class_info.is_online)
        setObservation(selectedStudent.observation)
        // Mantiene las propiedades del estudiante antes de obtener el historial de pagos
        setStudents(prevStudents => {
            const updatedStudents = [...prevStudents];
            updatedStudents[index] = {
                ...updatedStudents[index],
                id_student: selectedStudent.id,
                name: selectedStudent.name,
                schoolarship: {},
                concepts_to_pay: {
                    tuition: [],
                    books: [],
                    inscription: {}
                },
                id_class: selectedStudent.class_info.id || '',
                inscription_date: selectedStudent.inscription_date,



            };
            return updatedStudents;
        });
        if (showInscription) {
            toggleInscription()
        }

        try {
            const studentPaymentInfoResponse = await GetAllPaymentInfoByStudent(selectedStudent.id);
            if (studentPaymentInfoResponse.status === 200) {
                const history = await paymentHistoryFormat(studentPaymentInfoResponse.response.receipt);
                setPaymentPlan(studentPaymentInfoResponse.response.payment_plan)
                setScholarShip(studentPaymentInfoResponse.response.scholarship)
                setStudents(prevStudents => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[index] = {
                        ...updatedStudents[index],
                        paymentHistory: history, // Agrega el historial de pagos
                        schoolarship: studentPaymentInfoResponse.response.scholarship
                    };
                    return updatedStudents;
                });
            } else if (studentPaymentInfoResponse.status === 201) {
                setStudents(prevStudents => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[index] = {
                        ...updatedStudents[index],
                        paymentHistory: [], // Asegurar que el historial quede vacío
                    };
                    return updatedStudents;
                });
            }
        } catch (error) {
            console.error("Error obteniendo historial de pagos:", error);
        }
    };

    useEffect(() => {
        if (studentPaymentHistory.length !== 0) {
            let thereIsInscription = false;
            studentPaymentHistory.some((v) => {
                const conceptsReceipt = v.payment_detail.concepts;

                thereIsInscription = conceptsReceipt.some((cr) => {
                    return parseInt(cr.id) === 4; // Si se encuentra el concepto de inscripción
                });
                return thereIsInscription; // Detenemos el ciclo si se encuentra
            });

            if (student.inscription_date) {

                const ogInscription = formatToLocalDate(student.inscription_date);
                setInscriptionDate(ogInscription); // Guardamos la fecha formateada
            } else {
                const currentMonday = formatToLocalDate(getCurrentMondayISO());
                setInscriptionDate(currentMonday);
            }
            setButtonState(prev => ({
                ...prev,
                disabled_inscription: thereIsInscription
            }));
        } else {
            const ogInscription = formatToLocalDate(student.inscription_date);
            setInscriptionDate(ogInscription); // Guardamos la fecha formateada
            setButtonState(prev => ({
                ...prev,
                disabled_inscription: false
            }));
        }
    }, [studentPaymentHistory]);

    const paymentHistoryFormat = async (response) => {
        let paymentHistory = [];
        setStudentPaymentHistory(response);
        // Iteramos sobre cada pago en la respuesta
        await response.forEach(v => {
            let concepts = v.payment_detail.concepts.map(concept => concept.name);
            let amounts = v.payment_detail.concepts.map(concept => parseFloat(concept.amount));

            let combinedConcepts = {};
            let conceptWeeks = {}; // Para almacenar las semanas por concepto
            concepts.forEach((concept, index) => {
                if (combinedConcepts[concept]) {
                    combinedConcepts[concept] += amounts[index];
                    conceptWeeks[concept].push(v.payment_detail.concepts[index].week);
                } else {
                    combinedConcepts[concept] = amounts[index];
                    conceptWeeks[concept] = [v.payment_detail.concepts[index].week];
                }
            });

            // Creamos una lista de conceptos combinados y sus montos sumados
            let newConcept = Object.keys(combinedConcepts).join(", ");
            let newAmount = Object.values(combinedConcepts).join(", ");

            // Calculamos el porcentaje pagado por concepto
            let conceptPercentages = {};
            Object.keys(conceptWeeks).forEach(concept => {
                const weeks = conceptWeeks[concept];
                const totalPercentPaid = weeks.reduce((total, week) => {
                    const weekData = v.payment_detail.concepts.find(c => c.week === week);
                    return total + (weekData ? parseFloat(weekData.week.percent_paid) : 0);
                }, 0);

                const avgPercentPaid = weeks.length > 0 ? totalPercentPaid / weeks.length : 0;

                // Si el porcentaje es NaN o no se puede calcular, asignamos "No Aplica"
                conceptPercentages[concept] = isNaN(avgPercentPaid) ? "No Aplica" : `${avgPercentPaid.toFixed(2)}%`;
            });
            let object = {
                receipt_id: v.id,
                receipt_date: v.date_time,
                concept: newConcept,
                payedWeeks: v.payment_detail.concepts
                    .filter(concept =>
                        (concept.name === 'Abono' || concept.name === 'Colegiatura') &&
                        concept.week &&
                        concept.week.week &&
                        concept.week.year
                    )
                    .map(concept => ({
                        weekNumber: parseInt(concept.week.week),
                        year: parseInt(concept.week.year),
                        week: `${concept.week.week}-${concept.week.year}`,
                        percent_paid: concept.week.percent_paid
                    }))
                    .sort((a, b) => {
                        // Primero por año, luego por número de semana
                        if (a.year !== b.year) {
                            return a.year - b.year;
                        }
                        return a.weekNumber - b.weekNumber;
                    })
                    .map(({ week, percent_paid }) => ({ week, percent_paid })),

                amount: newAmount,
                conceptPercentages: conceptPercentages, // Almacenamos los porcentajes por concepto
            };

            paymentHistory.push(object);
        });
        return paymentHistory;
    };

    function getCurrentMondayISO() {
        const today = new Date();
        const day = today.getDay(); // 0 (domingo) a 6 (sábado)
        const diff = today.getDate() - day + (day === 0 ? -6 : 1); // lunes
        const monday = new Date(today.setDate(diff));
        return formatToLocalDate(monday); // devuelve YYYY-MM-DD en zona local
    }

    // Helper function to update student properties
    const updateStudent = (index, field, value) => {
        setStudents(prevStudents => {
            return prevStudents.map((student, i) => {
                if (i === index) {
                    return {
                        ...student,
                        concepts_to_pay: {
                            ...student.concepts_to_pay,
                            [field]: Array.isArray(student.concepts_to_pay[field])
                                ? // Si es un arreglo (como books o tuition), actualizamos el arreglo
                                [...student.concepts_to_pay[field], ...value] // Para agregar elementos al arreglo
                                : // Si no es un arreglo (como inscription), reemplazamos el valor directamente
                                value
                        }
                    };
                }
                return student;
            });
        });
    };

    // Toggle inscription fee visibility
    const toggleInscription = () => {
        setShowInscription(prev => !prev);
    };

    useEffect(() => {
        if (showInscription) {
            const hasValidScholarship = scholarShip && scholarShip.enrollment !== null;

            const discount = hasValidScholarship
                ? amountInscription * (scholarShip.enrollment / 100)
                : 0;

            const discountedAmount = amountInscription - discount;

            handleInscriptionChange(`$ ${discountedAmount}`);
        } else {
            setInscriptionValue('');
            updateStudent(index, 'inscription', {});
        }
    }, [showInscription]);


    useEffect(() => {
        if (!student?.promotions || student.promotions.length === 0) {
            return;
        }

        let applied = false;

        student.promotions.forEach((promo) => {
            if (appliedPromoIdsRef.current.has(promo.id)) {
                return;
            }

            if (promo.payment_concept === 'Inscripcion') {
                if (buttonsState.disabled_inscription) {
                    showAlert(
                        'info',
                        `No se puede aplicar el descuento ya que el alumno ${student.name} ya pagó inscripción`
                    );
                    return;
                }
                handleInscriptionPromotions(promo);
                appliedPromoIdsRef.current.add(promo.class_promotion_id);
                applied = true;
            }

            if (promo.payment_concept === 'Colegiatura') {
                handleCollegePromotions(promo);
                appliedPromoIdsRef.current.add(promo.class_promotion_id);
                applied = true;
            }
        });

        if (applied) {
            showAlert('success', `Promoción aplicada correctamente a ${student.name}`);
        }
    }, [student.promotions]);


    const handleInscriptionPromotions = async (promo) => {
        switch (promo.type) {
            case 'free':
                handleInscriptionChange(`$ 0`)
                break;
            case '2x1':
                const promoIndex = promo.index;
                if (promoIndex % 2 === 0) {
                    // Index par => se le aplica inscripción gratis
                    handleInscriptionChange(`$ 0`);
                } else {
                    handleInscriptionChange(`$ ${amountInscription}`);
                }
                break;
            case 'percentage':
                const discount = amountInscription * (parseFloat(promo.value) / 100)
                const discountedInscription = amountInscription - discount
                handleInscriptionChange(`$ ${discountedInscription}`)
                break;
            default:
                break;
        }
    }
    const handleCollegePromotions = async (promo) => {
        switch (promo.type) {
            case 'free':
                setStudents(prev => prev.map((s, i) =>
                    i === index ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b) =>
                                b.isTuition
                                    ? {
                                        ...b,
                                        amount: 0,
                                        date: b.date.map(d => ({
                                            ...d,
                                            tuition_payed: 0
                                        }))
                                    }
                                    : b
                            )
                        }
                    } : s
                ));
                break;
            case '2x1':
                showAlert('danger', 'NO HAY 2X1 EN COLEGIATURAS')
                break;
            case 'percentage':
                setStudents(prev => prev.map((s, i) =>
                    i === index ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b) =>
                                b.isTuition
                                    ? {
                                        ...b,
                                        amount: parseFloat((b.amount * (1 - parseFloat(promo.value) / 100)).toFixed(2)),
                                        date: b.date.map(d => ({
                                            ...d,
                                            tuition_payed: parseFloat((d.tuition_payed * (1 - parseFloat(promo.value) / 100)).toFixed(2))
                                        }))
                                    }
                                    : b
                            )
                        }
                    } : s
                ));
                break;
            default:
                break;
        }
    }

    // Add a new payment
    const addPayment = () => {
        if (student.concepts_to_pay.tuition.length < 5) {
            let today = getLocalDateObject();
            let days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
            let day = today.getDay();
            day = day === 0 ? 7 : day; // Convertimos domingo (0) en 7
            let dayName = days[day - 1]; // Restamos 1 porque el array empieza en 0

            // Determinar el monto según el día de la semana
            let tuitionAmount = 0;
            if (dayName === "Lunes" || dayName === "Martes" || dayName === "Miércoles") {
                tuitionAmount = paymentPlan.prompt; // Monto con descuento
            } else {
                tuitionAmount = paymentPlan.normal; // Monto normal
            }
            updateStudent(index, 'tuition', [{ isTuition: false, amount: 0, date: [], tuition_price: tuitionAmount }]);
        }
    };

    // Remove a payment by index
    const removePayment = (paymentIndex) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    tuition: s.concepts_to_pay.tuition.filter((_, j) => j !== paymentIndex)
                }
            } : s
        ));
    };

    // Add tuition if it does not already exist
    const addTuition = () => {
        let tuitionAmount = 0;
        updateStudent(index, 'tuition', [{ isTuition: true, amount: tuitionAmount, date: [], tuition_price: tuitionAmount }]);
        setStudentPay(tuitionAmount)
    };
    // Add a new book
    const addBook = () => {
        updateStudent(index, 'books', [{ id: '', name: '', amount: 0 }]);
    };

    // Remove a book by index
    const removeBook = (bookIndex) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    books: s.concepts_to_pay.books.filter((_, j) => j !== bookIndex)
                }
            } : s
        ));
    };
    // Handle changes in payment amount
    const handlePaymentAmountChange = (paymentIndex, value) => {
        const numericValue = value.replace(/[^0-9.]/g, ''); // Solo números y punto decimal
        const parsedValue = parseFloat(numericValue);

        setStudents(prev => {
            const updated = prev.map((s, i) =>
                i === index
                    ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b, j) =>
                                j === paymentIndex
                                    ? { ...b, amount: isNaN(parsedValue) ? "" : parsedValue }
                                    : b
                            )
                        }
                    }
                    : s
            );

            // Aquí ya puedes hacer el console.log
            // console.log('concepts_to_pay:', updated[index].concepts_to_pay);
            return updated;
        });
    };


    function getWeekNumber(date) {
        let d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        // Ajustar para que la semana inicie en lunes
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));

        // Calcular el inicio del año
        let startOfYear = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

        // Calcular la diferencia en días y obtener la semana
        let weekNumber = Math.ceil((((d - startOfYear) / 86400000) + 1) / 7);

        return { week: weekNumber, year: d.getUTCFullYear() };
    }


    // Handle changes in payment date
    // Handle changes in payment date
    const handlePaymentDateChange = (paymentIndex, date, tuitionAmount) => {
        if (date.length !== 0) {
            let today = new Date();
            let result = getWeekNumber(today);
            let tuiAmount = tuitionAmount
            if (tuiAmount === 0) {
                let today = new Date();
                let days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
                let day = today.getDay();
                day = day === 0 ? 7 : day; // Convertimos domingo (0) en 7
                let dayName = days[day - 1]; // Restamos 1 porque el array empieza en 0
                // Determinar el monto según el día de la semana
                if (dayName === "Lunes" || dayName === "Martes" || dayName === "Miércoles") {
                    tuiAmount = paymentPlan.prompt; // Monto con descuento
                } else {
                    tuiAmount = paymentPlan.normal; // Monto normal
                }
            }
            setStudents(prev => prev.map((s, i) =>
                i === index ? {
                    ...s,
                    concepts_to_pay: {
                        ...s.concepts_to_pay,
                        tuition: s.concepts_to_pay.tuition.map((b, j) => {
                            if (j === paymentIndex) {

                                const newDateArray = date.map(d => {
                                    let diff = (d.year - result.year) * 52 + (d.week - result.week);

                                    return {
                                        ...d,
                                        tuition_payed: diff < 0 ? paymentPlan.late
                                            : diff > 0 ? paymentPlan.prompt
                                                : tuiAmount
                                    };
                                });
                                if (!b.isTuition) {
                                    // Si no es colegiatura, se pone amount = 0 y date vacío o lo que quieras
                                    return {
                                        ...b,
                                        amount: 0,
                                        date: newDateArray // opcionalmente también puedes limpiar la fecha
                                    };
                                }
                                const newAmount = newDateArray.reduce((acc, item) => acc + item.tuition_payed, 0);

                                return {
                                    ...b,
                                    date: newDateArray,
                                    amount: newAmount
                                };
                            }
                            return b;
                        })
                    }
                } : s
            ));
        }
    };

    // a
    const handlePaymentDateChangeOnline = (paymentIndex, date, tuitionAmount) => {
        if (date.length !== 0) {
            let today = new Date();
            let result = getWeekNumber(today);

            // Verificar si la semana actual está incluida en las semanas seleccionadas
            const includesCurrentWeek = date.some(d => d.year === result.year && d.week === result.week);
            let tuiAmount = tuitionAmount
            if (tuiAmount === 0) {
                let today = new Date();
                let days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
                let day = today.getDay();
                day = day === 0 ? 7 : day; // Convertimos domingo (0) en 7
                let dayName = days[day - 1]; // Restamos 1 porque el array empieza en 0
                // Determinar el monto según el día de la semana
                if (dayName === "Lunes" || dayName === "Martes" || dayName === "Miércoles") {
                    tuiAmount = paymentPlan.prompt; // Monto con descuento
                } else {
                    tuiAmount = paymentPlan.normal; // Monto normal
                }
            }
            setStudents(prev => prev.map((s, i) =>
                i === index ? {
                    ...s,
                    concepts_to_pay: {
                        ...s.concepts_to_pay,
                        tuition: s.concepts_to_pay.tuition.map((b, j) => {
                            if (j === paymentIndex) {
                                const newDateArray = date.map(d => {
                                    let diff = (d.year - result.year) * 52 + (d.week - result.week);

                                    // Si se seleccionan 4 semanas y la semana actual está incluida, aplica el descuento
                                    if (date.length === 4 && includesCurrentWeek) {
                                        if (diff < 0) {
                                            return { ...d, tuition_payed: paymentPlan.late };  // Semana pasada: late
                                        } else if (diff === 0) {
                                            return { ...d, tuition_payed: paymentPlan.prompt };  // Semana actual: prompt
                                        } else {
                                            return { ...d, tuition_payed: paymentPlan.prompt };  // Semana futura: prompt
                                        }
                                    } else {  // Si se seleccionan de 1 a 3 semanas o 4 sin la actual
                                        return {
                                            ...d,
                                            tuition_payed: diff < 0 ? paymentPlan.late
                                                : diff > 0 ? paymentPlan.prompt
                                                    : tuiAmount
                                        };
                                    }
                                });

                                // Calcular el nuevo `amount` sumando todos los `tuition_payed`
                                const newAmount = newDateArray.reduce((acc, item) => acc + item.tuition_payed, 0);

                                // Si son 4 semanas consecutivas con la semana actual incluida, aplicar descuento
                                if (date.length === 4 && includesCurrentWeek) {
                                    const total = newAmount - 100;  // Aplicar descuento de $100
                                    return {
                                        ...b,
                                        date: newDateArray,
                                        amount: total
                                    };
                                } else {
                                    return {
                                        ...b,
                                        date: newDateArray,
                                        amount: newAmount
                                    };
                                }
                            }
                            return b;
                        })
                    }
                } : s
            ));
        }
    };





    // Handle inscription fee change
    const handleInscriptionChange = (value) => {
        // Elimina cualquier carácter no numérico (excepto el punto decimal)
        const numericValue = value.replace(/[^0-9.]/g, '');

        // Si el input está vacío, restablece el estado y actualiza el estudiante
        if (numericValue === '') {
            setInscriptionValue('');
            updateStudent(index, 'inscription', {}); // O el valor adecuado en tu lógica
            return;
        }

        // Convierte el valor en número flotante
        const parsedValue = parseFloat(numericValue);

        // Si el valor es NaN, no actualiza
        if (!isNaN(parsedValue)) {
            setInscriptionValue(numericValue);
            updateStudent(index, 'inscription', { amount: parsedValue });
        }
    };


    // Handle book selection change
    const handleBookSelectChange = (bookIndex, selectedValue) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    books: s.concepts_to_pay.books.map((b, j) =>
                        j === bookIndex
                            ? (() => {
                                const selectedBook = books.find(book => book.value === selectedValue);
                                return {
                                    id: selectedBook.value,
                                    name: selectedBook.label,
                                    price: selectedBook.price
                                };
                            })()
                            : b
                    )
                }
            } : s
        ));
    };
    // Función para construir el nombre completo
    const getFullName = (alumno) => {
        return `${alumno.name}`;
    };


    const ConfirmActionPassword = async () => {
        const checkPasswordConfirm = await handleConfirmActionPassword();
        const { status, message } = checkPasswordConfirm;
        if (!status) {
            return showAlert('info', message);
        }
        setDisabledTuition(false)


    };
    const ConfirmActionPasswordInscription = async () => {
        const checkPasswordConfirm = await handleConfirmActionPassword();
        const { status, message } = checkPasswordConfirm;
        if (!status) {
            return showAlert('info', message);
        }
        setDisabledInscriptionInput(false)


    };

    const handleConfirmActionPassword = () => {
        return new Promise((resolve) => {
            setIsPasswordRequired(true); // Abre el modal

            // Pasas estas funciones al modal para controlar los botones
            const handleAcceptPassword = (formValues) => {
                if (formValues.email !== '' && formValues.password !== '') {
                    const responseToConfirmation = PostReceptionistInCharge(formValues)
                    responseToConfirmation.then((value) => {
                        let status = value.status
                        if (value.hasOwnProperty("auth")) {
                            status = 202
                        }
                        switch (status) {
                            case 200:
                                setIsPasswordRequired(false); // Cierra el modal
                                resolve({ status: true, message: "Edicion Permitida" }); // Resuelve la promesa con "true" si acepta
                                break;
                            case 201:
                                resolve({ status: false, message: "Credenciales rechazadas para realizar la edición" })

                                break;
                            case 202:
                                resolve({ status: false, message: "Credenciales expiradas" })
                                break;
                            default:
                                break;
                        }

                    })
                } else {
                    showAlert('danger', 'Ingrese el correo y la contraseña para verificar sus credenciales.')
                }
            };

            const handleCancelPassword = () => {
                setIsPasswordRequired(false); // Cierra el modal
                resolve(false); // Resuelve la promesa con "false" si cancela
            };

            // Almacenar funciones en el estado para pasar al modal
            setModalHandlers({ handleAcceptPassword, handleCancelPassword });
        });
    }

    const handleSchoolarship = (paymentIndex) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    tuition: s.concepts_to_pay.tuition.map((b, j) => {
                        if (j === paymentIndex) {
                            const scholarship = s.schoolarship;
                            const hasValidScholarship = scholarship && scholarship.normal !== null;

                            const updatedDates = b.date.map(week => {
                                const original = week.tuition_payed;
                                const discount = hasValidScholarship
                                    ? original * (scholarship.normal / 100)
                                    : 0;
                                return {
                                    ...week,
                                    tuition_payed: original - discount,
                                };
                            });
                            const total = updatedDates.reduce((acc, w) => acc + w.tuition_payed, 0);
                            return {
                                ...b,
                                date: updatedDates,
                                amount: total,
                            };
                        }
                        return b;
                    })
                }
            } : s
        ));
    };

    return (
        <div className="student-section main-color">
            <div className="payment-actions">
                <Tooltip text="Eliminar alumno">
                    <Button backgroundColor="transparent" onClick={() => removeStudentSection(index)} Icon={CloseSVG} />
                </Tooltip>
            </div>
            {/* Select para elegir el alumno usando la lista extraída desde RECEIPTS */}
            <div className='autocomplete_select'>
                <InputAutoComplete
                    options={studentsList}// Pasa los objetos completos como opciones 
                    getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                    value={
                        studentsList.find(s => s.id === student.id_student) || null
                    } // Aquí pasas el objeto completo
                    onChange={(event, newValue) => handleStudentChange(newValue)}
                    isOptionEqualToValue={(option, value) => option.id === value.id} // Comparación basada en el 'id'
                    className={'search-box main-color'}
                    placeholder={"Buscar Alumno..."}
                />

            </div>
            <div className='student-section-content'>

                <div className="payment-concepts">
                    {student.concepts_to_pay?.tuition.map((payment, paymentIndex) => (
                        <div key={paymentIndex} className="tuition-data" >
                            <div className="payment-actions">
                                <Tooltip
                                    text={payment.isTuition ? "Eliminar colegiatura" : "Eliminar abono"}
                                >
                                    <Button backgroundColor="transparent"
                                        onClick={() => removePayment(paymentIndex)}
                                        Icon={CloseSVG}
                                    />
                                </Tooltip>
                            </div>
                            <div className='tuition-inputs'>
                                <InputDate
                                    selectionType={payment.isTuition ? "week-range" : "week"}
                                    valueType="weekNumber"
                                    value={payment.date}
                                    onChange={(date) =>
                                        isStudentClassOnline
                                            ? handlePaymentDateChangeOnline(paymentIndex, date, studentPay)
                                            : handlePaymentDateChange(paymentIndex, date, studentPay)
                                    }
                                    minDate={inscriptionDate}
                                    placeholder={"Seleccione semana(s) a pagar"}
                                    onClose={() => { handleSchoolarship(paymentIndex) }}
                                />
                                <div className='tuition-amount-qty'>
                                    <Tooltip text={'Selecciona semana a pagar para calcular costo (Colegiatura).'}>

                                        <InputAnimated
                                            type="text"
                                            placeholder={payment.isTuition ? "Colegiatura" : "Abono"}
                                            disabled={payment.isTuition ? disableTuition : false}
                                            className="tuition-amount"
                                            value={`$  ${payment.amount}`}
                                            onChange={(e) => handlePaymentAmountChange(paymentIndex, e.target.value)}
                                        />
                                    </Tooltip>
                                    <Tooltip text={'Editar cantidad a pagar manualmente (Requiere autorización).'}>
                                        <Button Icon={EditSVG} onClick={ConfirmActionPassword}></Button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    ))}
                    {showInscription && (
                        <div className="concept-item payment-actions inscription">
                            <Tooltip text="Eliminar inscripción">
                                <Button backgroundColor="transparent"
                                    onClick={toggleInscription}
                                    Icon={CloseSVG} />
                            </Tooltip>
                            <InputAnimated
                                type="text"
                                placeholder="Inscripción"
                                value={`$ ${inscriptionValue}`} // Muestra el valor con el símbolo "$"
                                onChange={(e) => handleInscriptionChange(e.target.value)}
                                disabled={disableInscriptionInput}

                            />
                            <Button Icon={EditSVG} onClick={ConfirmActionPasswordInscription}></Button>

                        </div>
                    )}

                    {student.concepts_to_pay?.books && student.concepts_to_pay.books?.map((bookValue, bookIndex) => {
                        return (
                            <div className="concept-item payment-actions" key={bookIndex}>
                                <Tooltip text="Eliminar libro">
                                    <Button backgroundColor="transparent"
                                        onClick={() => removeBook(bookIndex)}
                                        Icon={CloseSVG} />
                                </Tooltip>
                                <div className='concept-inputs'>
                                    <Select
                                        options={books}
                                        classN="main-color"
                                        placeholder="Selecciona un libro"
                                        value={bookValue?.id || ""}
                                        onChange={(selectedBook) => handleBookSelectChange(bookIndex, selectedBook.target.value)}
                                    />

                                    <InputAnimated
                                        type="text"
                                        placeholder="Precio de Libro"
                                        value={bookValue?.id ? `$  ${bookValue?.price}` : ''}
                                        readOnly
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Payment history section */}
                <div className="payment-history">
                    {student.paymentHistory && student.paymentHistory.length > 0 ?
                        <div className='paymente-history-content'>
                            <div className='student-notes'>
                                <h1 className='title-2'>Observaciones</h1>
                                <textarea value={observation} readOnly></textarea>
                                {/* <Button text='Guardar cambios' />  */}
                            </div>
                            <PaymentHistory student={student} paymentPlan={paymentPlan} /> </div> : !student.id_student && student.paymentHistory.length === 0 ? <div className='payment-history-txt'>  Selecciona un alumno para mostrar historial de pago</div> : <div className='payment-history-txt'>  El alumno no cuenta con ningun pago    </div>
                    }
                </div>
            </div>

            <div className="student-section-buttons">
                {!showInscription &&
                    <Tooltip text={'Solo es posible agregar inscripcion cuando el alumno No ha realizado ese pago'}>
                        <Button disabled={student.id_student && !buttonsState.disabled_inscription ? false : true} text="+ Inscripción" onClick={toggleInscription}
                        />
                    </Tooltip>
                }
                <Tooltip text={'Añadir sección de libro'}>
                    <Button disabled={student.id_student ? false : true} text="+ Libro" onClick={addBook} />
                </Tooltip>
                {!student.concepts_to_pay?.tuition?.some(payment => !payment.isTuition) && (
                    <Tooltip text={'Solo se pueden abonar semanas consecutivas ó de vacaciones'} position='left'>
                        <Button disabled={student.id_student ? false : true} text="+ Abono" onClick={addPayment} />
                    </Tooltip>

                )}
                {!student.concepts_to_pay?.tuition?.some(payment => payment.isTuition) && (
                    <Tooltip text={'Añadir semanas de colegiatura a pagar'}>
                        <Button disabled={student.id_student ? false : true} text="+ Colegiatura" onClick={addTuition} />
                    </Tooltip>
                )}
            </div>
            {isPasswordRequired && <PasswordAlert handleAccept={modalHandlers.handleAcceptPassword} isOpen={isPasswordRequired} handleCancel={modalHandlers.handleCancelPassword}
                text={'Ingrese las credenciales'}
                title={'Se necesita autorizacion'}
            />}
        </div>
    );
};

export default StudentSection;
